import {Pipe, PipeTransform, inject} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({name: "url"})
export class UrlPipe implements PipeTransform {
    private domSanitizer: DomSanitizer = inject(DomSanitizer);

    transform(value) {
        return this.domSanitizer.bypassSecurityTrustUrl(value);
    }
}
